import SurveyCard from "./SurveyCard.vue"

export default SurveyCard